import { z } from 'zod';

// Generic schema for cached responses
export const CachedDataSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z.object({
    data: dataSchema,
    lastUpdated: z.coerce.date().nullable(),
  });
export type CachedData<T> = { data: T; lastUpdated: Date | null };
